import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {Card, CardTitle} from "reactstrap";
import humanizeString from "string-humanize";
import {useMediaQuery} from "react-responsive";

/** This component will be rendered when there in no data to be displayed on table */

function NoData(props) {
  const {headers = [], withActions = false, noDataText = "No Results Found"} = props;
  const isMobileOrTablet = useMediaQuery({query: "(max-width: 1080px)"});
  const buildReadableHeader = (header) => {
    let header_list = header.split(".");
    header = header_list[header_list.length - 1];
    return humanizeString(header).replace("Is", "");
  };

  return (
    <Fragment>
      {!isMobileOrTablet ? (
        <Card className="shadow" data-cy={"no-data-card"}>
          <table className="table zeus-table table-curved">
            <thead>
              <tr className="table-left">
                {headers.map((header) => (
                  <th tabIndex="0" key={header} className="table__header">
                    <span>
                      {buildReadableHeader(
                        header === "street_address1" ? "Address" : header
                      )}
                    </span>
                  </th>
                ))}
                {withActions && <th className="table__header">Actions</th>}
              </tr>
            </thead>
          </table>

          <CardTitle
            tag={"h1"}
            className="d-flex justify-content-center roboto-bold"
            style={{marginTop: "30px"}}
          >
            {noDataText}
          </CardTitle>
        </Card>
      ) : (
        <Card
          style={{
            minHeight: "150px",
            paddingTop: "50px",
            textAlign: "center",
            fontSize: "24px",
          }}
          className={"roboto-bold"}
          data-cy={"no-data-card"}
        >
          <CardTitle>{noDataText}</CardTitle>
        </Card>
      )}
    </Fragment>
  );
}

NoData.propTypes = {
  /** List of headers to display on table.
   *  They need to match the row object keys */
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** Wether to display action column on table */
  withActions: PropTypes.bool,
  /** Text to show no data is present */
  noDataText: PropTypes.string,
};

export default NoData;
